import useDataHook from "./useDataHook";

function FavoriteUrlViewer() {
    const [loading, data, errors] = useDataHook('/FavoriteUrl/GetFavoriteUrls',null);

    return (<>

        {loading ? <div>Loading</div> : <ul>
            {data.map((x => <li key={x.favoriteUrlID}> <a href={x.url} target='_blank' rel='noreferrer' >{x.urlName} </a> </li>))}
        </ul>}


        {errors && <div>{errors}</div>}

    </>
    )
}



export default FavoriteUrlViewer;